<template>
  <v-app-bar clipped-left app class="toolbar_custom" :height="height">
    <v-btn
      absolute
      left
      icon
      @click="$store.commit('modules/toggleDrawer', !$store.getters['modules/showDrawer'])"
      v-if="
        !$vuetify.breakpoint.lgAndUp &&
        ($route.path.includes('lessons-view') || $route.path.includes('admin'))
      "
    >
      <v-icon>mdi-menu</v-icon>
    </v-btn>
    <v-img
      :max-height="max_height"
      :max-width="$vuetify.breakpoint.xs ? max_height : max_width"
      contain
      :src="
        $vuetify.breakpoint.xs
          ? require('../assets/logo.png')
          : require('../assets/logo_text_right.png')
      "
      class="cursor_pointer ml-12"
    ></v-img>
    <v-spacer></v-spacer>
    <div class="mr-6 d-flex align-content-center flex-column">
      <v-avatar size="48" :color="profile.avatar ? '' : 'indigo'" class="align-self-center">
        <v-img v-if="profile.avatar" :src="profile.avatar" />
        <v-icon v-else dark>mdi-account-circle</v-icon>
      </v-avatar>
      <v-menu :close-on-content-click="false" :nudge-width="200" offset-x>
        <template v-slot:activator="{ on }">
          <v-btn
            text
            x-small
            v-on="on"
            class="align-self-center mt-2 text-capitalize font-weight-semibold body-2"
          >
            {{ `${profile.first_name} ${profile.last_name}` }}
            <v-icon>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-list>
            <v-list-item @click="editDialog = true">
              <v-list-item-content>
                <v-list-item-title>{{
                  `${profile.first_name} ${profile.last_name}`
                }}</v-list-item-title>
                <v-list-item-subtitle class="text-capitalize">{{
                  profile.role.toLowerCase()
                }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>Edit Profile</v-list-item-action>
            </v-list-item>

            <v-divider />
            <template v-if="isTeacher">
              <v-hover #default="{ hover }">
                <v-list-item @click="dialog = true">
                  <v-list-item-content>
                    <template v-if="student">
                      <v-list-item-title>{{
                        `${student.first_name} ${student.last_name}`
                      }}</v-list-item-title>
                      <v-list-item-subtitle>
                        <span class="text-capitalize">Current Student</span>
                      </v-list-item-subtitle>
                    </template>
                    <template v-else>
                      <v-list-item-title>Please select a student</v-list-item-title>
                      <v-list-item-subtitle>
                        <span class="text-capitalize">No student selected</span>
                      </v-list-item-subtitle>
                    </template>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-avatar :color="!student ? 'indigo' : ''" class="align-self-center">
                      <template v-if="!hover">
                        <v-icon v-if="!student" dark>mdi-account-circle</v-icon>
                        <v-img v-else-if="student.avatar" :src="student.avatar" />
                      </template>
                      <v-icon :color="!student ? 'white' : '#29284c'" size="36" v-else
                        >mdi-account-convert</v-icon
                      >
                    </v-avatar>
                  </v-list-item-action>
                </v-list-item>
              </v-hover>
              <v-divider />
            </template>
            <template
              v-if="
                $store.getters.profile &&
                $store.getters.profile.role === 'STUDENT' &&
                $route.path.includes('lessons-view')
              "
            >
              <v-list-item @click="onCheckLesson">
                <v-list-item-content>{{
                  onHold ? "Notification Sent!" : "Notify your teacher!"
                }}</v-list-item-content>
                <v-list-item-action>
                  <v-icon color="#29284c">{{ onHold ? "mdi-clock" : "mdi-telegram" }}</v-icon>
                </v-list-item-action>
              </v-list-item>
              <v-divider />
            </template>
            <v-list-item @click="onOpenAssignments">
              <v-list-item-content>
                <v-list-item-title>Assignments</v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>mdi-format-list-checks</v-icon>
              </v-list-item-icon>
            </v-list-item>
            <v-divider />
            <template v-if="!['ADMIN', 'EDITOR'].includes($store.state.profile.role)">
              <v-list-item to="/cloud">
                <v-list-item-content>
                  <v-list-item-title> Cloud </v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-icon> mdi-cloud </v-icon>
                </v-list-item-icon>
              </v-list-item>

              <v-divider />
            </template>
          </v-list>

          <v-card-actions>
            <v-btn
              @click="logoutUser"
              small
              depressed
              class="text-capitalize caption white--text my-3 mx-auto"
              color="#FF347C"
              >Logout</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-menu>
    </div>
    <app-students-dialog v-model="dialog" :action="action" />
    <app-edit-dialog v-model="editDialog" />
  </v-app-bar>
</template>

<script>
import StudentsDialog from "./StudentsDialog.vue";
import EditDialog from "./EditDialog.vue";
import { requestRevision } from "@/api/api";
import { openStudentTasksPending } from "@/utils/nuxtAppNavigation";

export default {
  name: "Toolbar",
  components: {
    appStudentsDialog: StudentsDialog,
    appEditDialog: EditDialog,
  },
  data: () => ({
    height: 100,
    max_height: 58,
    max_width: 225,
    editDialog: false,
    onHold: false,
  }),
  computed: {
    student: {
      get() {
        return this.$store.getters.student;
      },
      set(value) {
        this.$store.commit("updateStudent", value);
      },
    },
    dialog: {
      get() {
        return this.$store.getters.studentDialog;
      },
      set(value) {
        this.$store.commit("studentDialog", value);
      },
    },
    isTeacher() {
      if (this.profile) {
        return this.profile.role.toLowerCase() === "teacher";
      } else return false;
    },
    profile() {
      return this.$store.getters.profile;
    },
  },
  created() {
    if (!this.student && this.isTeacher) this.dialog = true;
  },
  methods: {
    logoutUser() {
      this.$store.dispatch("logoutUser");
    },
    onOpenAssignments() {
      openStudentTasksPending();
    },
    action(item) {
      this.$store.commit("updateStudent", item);
      if (this.$route.name !== "modules") {
        this.$router.push({ name: "modules" });
      }
      this.dialog = false;
    },
    async onCheckLesson() {
      if (!this.onHold) {
        let section = "live";
        if (this.$route.name === "practice") {
          section = "practice";
        } else if (this.$route.path.includes("grammar")) {
          section = "grammar";
        }

        await requestRevision({
          lesson_progress: this.$store.getters["progress/lesson"].uuid,
          section: section,
        });
        this.onHold = true;
        setTimeout(() => {
          this.onHold = false;
        }, 300000);
      }
    },
  },
};
</script>
<style scoped>
.toolbar_custom {
  background: #ffffff 0% 0% no-repeat padding-box !important;
  box-shadow: 0px 3px 6px #0000001a;
}
</style>
